(function() {
  define('tlhComponentsOpenModal',['angular', 'angularAnimate', 'angularBootstrap'], function() {
    'use strict';
    return angular.module('tlhComponentsOpenModal', ['ngAnimate']).directive('tlhOpenModal', [
      '$uibModal', function($uibModal) {
        return {
          restrict: 'A',
          scope: {
            modalTemplateUrl: '@tlhOpenModal'
          },
          link: function(scope, element) {
            return element.on('click', function(e) {
              $uibModal.open({
                templateUrl: scope.modalTemplateUrl
              });
              return false;
            });
          }
        };
      }
    ]);
  });

}).call(this);

//# sourceMappingURL=openModal.js.map
;
